import { apiPost } from '../utils/apiUtils';
import { AUTH_ENDPOINTS } from '../config/api';

/**
 * Authentication service that handles API calls for login and token management
 */

// Login with contact number and password
export const loginUser = async (contactNumber, password) => {
  try {
    const data = await apiPost(AUTH_ENDPOINTS.LOGIN, {
      ContactNumber: contactNumber,
      PasswordHash: password
    });
    
    return data;
  } catch (error) {
    console.error('Login API error:', error);
    
    // Return a consistent error format
    return {
      error_code: error.response?.data?.error_code || 500,
      success: false,
      message: error.response?.data?.message || 'Login failed. Please try again.',
      result: null
    };
  }
};

// Store user data in local storage
export const setUserSession = (userData) => {
  if (userData) {
    localStorage.setItem('user', JSON.stringify(userData));
    // Generate a simple token based on user ID
    const token = `user-${userData.User_ID}-${new Date().getTime()}`;
    localStorage.setItem('token', token);
    return token;
  }
  return null;
};

// Get user data from local storage
export const getUserData = () => {
  const userStr = localStorage.getItem('user');
  try {
    if (userStr) {
      return JSON.parse(userStr);
    }
  } catch (e) {
    console.error('Error parsing user data from localStorage', e);
  }
  return null;
};

// Clear user data from local storage
export const clearUserSession = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('token');
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!localStorage.getItem('token') && !!getUserData();
};

// Get user role
export const getUserRole = () => {
  const userData = getUserData();
  return userData?.Role?.Name || null;
}; 